import React from "react";

import styles from "./styles.module.scss";
import DatePicker from "app/components/DatePicker";

const LessonPanel = ({ lessonProperties, setViewDate, coaches }) => {
  return (
    // CN-2652: the coach and session selects that used to head this panel are
    // now the two cards above the calendar (BookingCards) — the frame puts each
    // choice behind a chevron beside its name. This panel is the calendar.
    <div className={styles.panel_container} data-testid="lesson-pannel">
      <DatePicker
        date={lessonProperties.date}
        setDate={setViewDate}
        minDate={new Date()}
        coach={coaches}
        minutesDuration={lessonProperties.duration?.durationInMinutes}
        pricingValue={lessonProperties.pricingValue}
        inline={true}
      />
    </div>
  );
};

export default LessonPanel;
